export default "__VITE_ASSET__VGTiPoeA__"